import { render, staticRenderFns } from "./ManajemenTokoDialogs.vue?vue&type=template&id=1764720e&scoped=true&"
import script from "./ManajemenTokoDialogs.vue?vue&type=script&lang=js&"
export * from "./ManajemenTokoDialogs.vue?vue&type=script&lang=js&"
import style0 from "./ManajemenTokoDialogs.vue?vue&type=style&index=0&id=1764720e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764720e",
  null
  
)

export default component.exports